import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MainService {
 apiHost: any
  apiPort: any
  baseUrl: any
  

  constructor(private http: HttpClient) { }
   async getAllEnvConfig(object: any) {
    this.apiHost = object.apiHostDd || "http://localhost";
    this.apiPort = object.apiPortDd || 3000;



    this.baseUrl = this.apiHost + ':' + this.apiPort + '/dd';
    console.log('ddAPI @ ' + this.baseUrl + ' is being used.');
  }

  get(obj: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, obj);
  }

  getClassifications(obj: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, obj);
  }

  createClassification(data: any): Observable<any> {  
    return this.http.post(`${this.baseUrl}`, data);
  }

  getHierarchy(obj: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, obj);
  }

  getDiData(obj: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, obj);
  }

  getTerms(obj: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, obj);
  }

  getClassificationsForTerm(obj: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, obj);
  }

  insert(obj: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, obj);
  }

  update(obj: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, obj);
  }

  destroyHierarchy(obj: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, obj);
  }

  createHierarchyNode(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/hierarchy`, data);
  }
}